import fiveDays from '../../www/assets/svg/achievement/5 Days.svg';
import actionPlan from '../../www/assets/svg/achievement/ActionPlan.svg';
import actionPlanArchive from '../../www/assets/svg/achievement/actionPlanTransparant.svg';
import cv from '../../www/assets/svg/achievement/CV.svg';
import CompletingQuiz from '../../www/assets/svg/achievement/CompletingQuiz.svg';
import quizArchive from '../../www/assets/svg/achievement/quizTransparant.svg';
import newsFeed from '../../www/assets/svg/achievement/Newsfeed.svg';
import newsFeedArchive from '../../www/assets/svg/achievement/newsfeedTransparant.svg';
import profile from '../../www/assets/svg/achievement/Profile.svg';
import selfAssessment from '../../www/assets/svg/achievement/Self Assessment.svg';
import selfAssessmentArchive from '../../www/assets/svg/achievement/selfassessmentTransparant.svg';
import selfAssessmentAndAP from '../../www/assets/svg/achievement/SelfAssess&AP.svg';
import selfAssessmentAndAPArchive from '../../www/assets/svg/achievement/SelfAssess&APtransparant.svg';
import starEmployee from '../../www/assets/svg/achievement/StarEmployee.svg';
import watchingVideo from '../../www/assets/svg/achievement/WatchingVideo.svg';
import watchingVideoArchive from '../../www/assets/svg/achievement/watchingVideoTransparant.svg';
import starTransparent from '../../www/assets/svg/achievement/starTransarent.svg';
import january from '../../www/assets/svg/achievement/january.svg';
import february from '../../www/assets/svg/achievement/feb.svg';
import march from '../../www/assets/svg/achievement/March.svg';
import april from '../../www/assets/svg/achievement/april.svg';
import may from '../../www/assets/svg/achievement/may.svg';
import june from '../../www/assets/svg/achievement/June.svg';
import july from '../../www/assets/svg/achievement/July.svg';
import august from '../../www/assets/svg/achievement/Aug.svg';
import september from '../../www/assets/svg/achievement/Sept.svg';
import october from '../../www/assets/svg/achievement/Oct.svg';
import november from '../../www/assets/svg/achievement/Nov.svg';
import december from '../../www/assets/svg/achievement/Dec.svg';

const getMonthImage = (month) => {
  switch (month) {
    case '1':
      return january;
    case '2':
      return february;
    case '3':
      return march;
    case '4':
      return april;
    case '5':
      return may;
    case '6':
      return june;
    case '7':
      return july;
    case '8':
      return august;
    case '9':
      return september;
    case '10':
      return october;
    case '11':
      return november;
    case '12':
      return december;
    default:
      return;
  }
};

export {
  fiveDays,
  actionPlan,
  actionPlanArchive,
  cv,
  CompletingQuiz,
  quizArchive,
  newsFeed,
  newsFeedArchive,
  profile,
  selfAssessmentAndAP,
  selfAssessmentAndAPArchive,
  selfAssessment,
  selfAssessmentArchive,
  starEmployee,
  watchingVideo,
  watchingVideoArchive,
  starTransparent,
  getMonthImage,
};
